import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router";
import { JOBS_ALERTS_LEGEND } from "@constants";

class Table extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			collapse: false,
		};
	}

	toggleTable = () => {
		const { collapse } = this.state;
		this.setState({ collapse: !collapse });
	};

	render() {
		const { data, columns, title } = this.props;
		const { collapse } = this.state;

		const rows = data.map((row, index) => {
			const _columns = columns.map((column, columnIndex) => {
				const value = row[column.property];
				let content = value;
				let newTitle = null;

				if (column.urlBase) {
					content = <Link to={column.urlBase.replace("%value%", value)}>{value}</Link>;
				}

				if (column.title && column.property === "alerts" && value !== "") {
					newTitle = value
						.split("/")
						.reduce((acc, item) => `${acc} / ${JOBS_ALERTS_LEGEND[item] || ""}`, "")
						.substr(3);
				}

				return (
					<td
						key={columnIndex /* eslint-disable-line react/no-array-index-key */}
						title={newTitle}
						className={column.class || ""}
					>
						{content}
					</td>
				);
			});

			return (
				<tr key={index /* eslint-disable-line react/no-array-index-key */}>{_columns}</tr>
			);
		});

		let header = "";
		if (title) {
			header = (
				<button
					type="button"
					onClick={this.toggleTable}
					tabIndex={0}
					className="table-title-btn"
				>
					<h4 className="table-title">
						<i
							className={classNames({
								rkf: true,
								"rkf-caret-right": collapse,
								"rkf-caret-down": !collapse,
							})}
						/>
						{title}
					</h4>
				</button>
			);
		}

		const newColumns = columns.map((column, index) => (
			<th
				key={index /* eslint-disable-line react/no-array-index-key */}
				className={`report-heading ${column.class || ""}`}
			>
				{column.name}
			</th>
		));

		return (
			<div className="panel-table-wrapper legacy table-responsive">
				{header}
				<table className={classNames({ table: true, collapse })}>
					<thead>
						<tr>{newColumns}</tr>
					</thead>
					<tbody>{rows}</tbody>
				</table>
			</div>
		);
	}
}

Table.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
	title: PropTypes.string,
};

Table.defaultProps = {
	title: "",
};

export default Table;
